import React, {useRef} from "react"
import ComponentWrapper from "../components/wrapper"
import ScrollAnimation from "../helpers/scrollAnimations"
import { Link } from "gatsby"
import ToolTip from "./tooltip"

const HowToHelp = ({reverseZindex, bodyCopy, ctaButton, headline, hasTooltip=false, tooltip, storyColor }) => {
    const parentCopyEl = useRef(null);

    return (
        <ComponentWrapper>
            <ScrollAnimation zIndex={reverseZindex}>
            {
                // horizontal line goes here
                <div className="how-to-help">
                    <h2 className="h2 sans">{headline}</h2>
                    <div className="p1 sans" ref={parentCopyEl} dangerouslySetInnerHTML={{ __html: bodyCopy}} />
                    {ctaButton &&
                        <Link to={ctaButton.url} className={`button button--${storyColor}`}>{ctaButton.title}</Link>
                    }
                    {hasTooltip &&
                        <ToolTip
                            storyColor={storyColor}
                            tooltip={tooltip}
                            parentCopy={parentCopyEl}
                        />
                    }
                </div>
            }
            </ScrollAnimation>
        </ComponentWrapper>
    )
}

export default HowToHelp